import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import RoomsTable from './RoomsTable';
import { Link } from 'react-router-dom';

const Rooms = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Rooms" title="Rooms" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Rooms</H5>
                <Link to="/rooms/new">
                  <Btn color="primary">New room</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <RoomsTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Rooms;
